import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { APP_CONFIG } from '@/constants/app-config';
import { PATHS } from '@/constants/page-paths';
import {
  apiForgotPassword,
  apiRegister,
  apiResetPassword,
  apiSignIn,
  apiSignOut,
  apiVerifyEmail,
} from '@/services/auth.api';
import { useTokenStore, useUserStore } from '@/store';
import { UseSignOutProps } from '@/types/others';
import useUrlParams from './useParams';

export const useAuth = () => {
  const { token, setToken } = useTokenStore();
  const { setAuthenticated, setUser, isAuthenticated } = useUserStore();
  const navigate = useNavigate();
  const params = useUrlParams();

  const signInUser = (data: Record<string, unknown>) => {
    const { token, is2faEnabled, ...userInfo } = data || {};
    if (!is2faEnabled) {
      setToken(token as string);
      setAuthenticated(true);
      setUser(userInfo);
      const persistedRedirectUrl = localStorage.getItem('redirectUrl');
      const redirectUrl =
        params.get(APP_CONFIG.REDIRECT_URL_KEY) || persistedRedirectUrl;
      navigate(redirectUrl ? redirectUrl : APP_CONFIG.authenticatedEntryPath);
    }
  };

  const {
    mutateAsync: signIn,
    isLoading: isSignInPending,
    ...singInData
  } = useMutation({
    mutationFn: apiSignIn,
    onSuccess: (res) => {
      // invalidateQuery(['twin']);
      console.log('success response >>', res);
      const { accessToken, ...userInfo } = res.data.data;
      console.log(accessToken, 47);
      setToken(accessToken);
      setAuthenticated(true);
      setUser(userInfo);
      navigate(PATHS.HOME, { replace: true });
    },
  });

  const {
    mutateAsync: logOut,
    isLoading: isSingOutPending,
    ...signOutData
  } = useMutation({
    mutationFn: apiSignOut,
    onSuccess: () => {
      setToken(null);
    },
  });
  const signOut = async ({
    apiCall = true,
    state,
    redirect,
  }: UseSignOutProps = {}) => {
    localStorage.removeItem('redirectUrl');
    if (apiCall) {
      await logOut();
    } else {
      setToken(null);
    }
    setAuthenticated(false);
    setUser(null);
    navigate(redirect ?? PATHS.SIGN_IN, { replace: true, state });
  };

  const registerUser = useMutation({
    mutationFn: apiRegister,
    onSuccess: () => {
      localStorage.setItem('RegisterSuccess', 'true');
      navigate('/sign-in');
    },
    onError: (err) => {
      console.log('err>>', err);
    },
  });

  const {
    mutateAsync: verifyEmail,
    isLoading: isVerifyPending,
    ...verifyData
  } = useMutation({
    mutationFn: apiVerifyEmail,
  });

  const forgotPassword = useMutation({
    mutationFn: apiForgotPassword,

    onSuccess: () => {
      // navigate(PATHS.RESET_PASSWORD);
      console.log('Success in forget password>>');
    },

    onError: (err) => {
      console.log('Error in forget password >>', err);
    },
  });

  const resetPassword = useMutation({
    mutationFn: apiResetPassword,

    onSuccess: () => {
      console.log('Reset Password Success>>');
      localStorage.setItem('ResetPasswordSuccess', 'true');
      navigate(PATHS.SIGN_IN);
    },
    onError: (err) => {
      console.log('Error in reset password>>', err);
    },
  });

  return {
    singInData,
    signIn,
    isSignInPending,
    isAuthenticated,
    token,
    isSingOutPending,
    signOut,
    signOutData,
    registerUser,
    verifyEmail,
    isVerifyPending,
    verifyData,
    forgotPassword,
    resetPassword,
    signInUser,
  };
};
